import dynamic from "next/dynamic";

export const StatisticsIcons = dynamic(() => import("./component"));
